import { useState } from "react";

export function useContactUs() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [contact, setContact] = useState("");
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [otp, setOtp] = useState("");

    return { firstName, setFirstName, lastName, setLastName, contact, setContact, message, setMessage, subject, setSubject, otp, setOtp }
}